export const TOGGLE_COMING_SOON_MODAL = 'TOGGLE_COMING_SOON_MODAL';

export const toggleComingSoonModal = () => ({
  type: TOGGLE_COMING_SOON_MODAL
})